module.exports = require('./helpers/bundle-url').getBundleURL('3iBM7') + "spotlight-hero.1366f29c.svg";